<template lang="pug">
  b-row
    b-col(sm='12')
      form(@submit.prevent="submit")
        b-card
          div(slot="header")
            strong {{ formName }}
            small.pl-2 Form

          b-row
            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label="First Name")
                  b-form-input(
                    type="text"
                    id="user_first_name"
                    name="first_name"
                    placeholder="Enter user's first name"
                    v-model='user.first_name'
                  )
              b-col(sm='12')
                b-form-fieldset(label="Last Name")
                  b-form-input(
                    type="text"
                    id="user_last_name"
                    name="last_name"
                    placeholder="Enter user's last name"
                    v-model='user.last_name'
                  )
              b-col(sm='12')
                b-form-fieldset(label="Company")
                  b-form-input(
                    type="text"
                    id="user_company"
                    name="company"
                    placeholder="Enter user's company name"
                    v-model='user.company'
                  )
              b-col(sm='12')
                b-form-fieldset(label="Role")
                  b-form-select(
                    :plain="true"
                    :options='roleOptions'
                    id='user_role'
                    name='role'
                    v-validate="'required'"
                    v-model='user.role'
                  )
                  div.text-danger(v-show="errors.has('role')") {{ errors.first('role') }}

            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label="Email")
                  b-form-input(
                    type="email"
                    id="user_email"
                    name="email"
                    placeholder="Enter user's email address"
                    v-validate="'required|email'"
                    v-model='user.email'
                  )
                  div.text-danger(v-show="errors.has('email')") {{ errors.first('email') }}

              b-col(sm='12')
                b-form-fieldset(label="Password")
                  b-form-input(
                    type="password",
                    id="user_password",
                    name="password",
                    placeholder="Enter user's password",
                    v-validate="validations.password",
                    v-model='user.password'
                  )
                  div.text-danger(v-show="errors.has('password')") {{ errors.first('password') }}

              b-col(sm='12')
                b-form-fieldset(label="Password Confirmation")
                  b-form-input(
                    type="password",
                    id="user_password_confirmation",
                    name="password_confirmation",
                    placeholder="Re-enter user's password",
                    v-validate="password_confirmation_rules",
                    v-model='user.password_confirmation'
                  )
                  div.text-danger(v-show="errors.has('password_confirmation')") {{ errors.first('password_confirmation') }}

          b-col.py-4(sm='12')
            button.btn.btn-primary.px-4(type='submit') Save
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import { options } from '@/utils/resourceNormalizer'

  export default {
    name: 'UserForm',
    data () {
      return {
        roleOptions: options['user_role'],
        formName: 'Create a new User',
        validations: {
          password: 'required|min:12'
        },
        user: {
          first_name: '',
          last_name: '',
          company: '',
          email: '',
          password: '',
          password_confirmation: '',
          role: ''
        }
      }
    },
    computed: {
      password_confirmation_rules () {
        if (this.$data.user.password) {
          return this.$data.user.password.length ? 'required|confirmed:password' : ''
        }
        return ''
      }
    },
    mounted () {
      if (this.isEdit()) {
        this.$set(this.$data, 'formName', "Modify user's informations")
        this.$set(this.$data.validations, 'password', 'min:12')
        this.fetchUser(this.$route.params.id)
      }
    },
    methods: {
      isEdit () {
        return this.$route.params.hasOwnProperty('id')
      },
      fetchUser (userId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        server.get('/users/' + userId)
          .then(res => {
            let user = res.data.user
            this.$set(this.$data.user, 'first_name', user.first_name)
            this.$set(this.$data.user, 'last_name', user.last_name)
            this.$set(this.$data.user, 'company', user.company)
            this.$set(this.$data.user, 'email', user.email)
            this.$set(this.$data.user, 'role', user.role)
          })
          .catch(err => {
            console.log(err)
          })
      },
      submit () {
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.saveUser(this.$route.params.id)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      saveUser (id = null) {
        let url = RouteGen.create('user')
        let verb = 'post'
        let messageModifier = 'created'
        if (id) {
          url = RouteGen.edit('user', id)
          verb = 'patch'
          messageModifier = 'updated'
        }
        server[verb](url, { user: this.$data.user })
          .then(res => {
            this.showNotification(201, messageModifier)
            this.$router.push({ name: 'All users' })
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'User', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User/Form.vue